import { createFileRoute } from '@tanstack/react-router';
import { SqlSyncNewRouteView } from '@/pages/workspaces/integrations/sql-sync/routing';
import { parseDraftIdParam } from '@/pages/workspaces/integrations/sql-sync/new/draft';
import { LastWorkspaceResolver } from './-components';

type SqlSyncNewSearch = {
  /**
   * The saved draft to resume. A number in the URL (`?id=7`): the router JSON-quotes a
   * numeric-looking string, and the embedded Ember app reads the same param unquoted.
   */
  id?: number;
};

/**
 * The create wizard for one engine. `?id=` resumes a saved draft.
 *
 * No `appBundle`: this URL has no `journeys` segment, and the bundle-aware branch of the resolver
 * rebuilds the target from the bundle prefix — which would find no `/journeys/` here, drop the
 * sub-path, and land on the Journeys home instead of this page.
 */
function SqlSyncNewRoute() {
  const { type } = Route.useParams();
  const { id } = Route.useSearch();

  return (
    <LastWorkspaceResolver>
      <SqlSyncNewRouteView type={type} draftId={id == null ? null : String(id)} />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/new')({
  component: SqlSyncNewRoute,
  // Spread the incoming params to preserve global ones the page does not own, and only refine `id`.
  // oxlint-disable-next-line local-rules/no-unsafe-dictionary-type -- validateSearch is handed unparsed search input, and the pass-through carries those same unvalidated values
  validateSearch: (search: Record<string, unknown>): Record<string, unknown> & SqlSyncNewSearch => ({
    ...search,
    id: parseDraftIdParam(search.id),
  }),
});
